import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("email", {
    createLetterTemplate: "Создать шаблон письма",
    noTemplatesFound: "Шаблонов не найдено",
    posterNotFound: "Постер не найден",
    maximumFileSizeExceeded: "Превышен максимальный размер файла",
    maximumFileResolutionExceeded: "Превышено максимальное разрешение файла",
    templateName: "Название шаблона",
    templateDescription: "Описание шаблона",
    subjectLine: "Тема письма",
    poster: "Постер",
    templatePosterTooltip: `По умолчанию подтягивается из общих настроек.
    Изображение .jpg или .png. Разрешение не должно
    превышать 1920x1080 px, размер файла не более 1 мб`,
    edit: "Изменить",
    delete: "Удалить",
    upload: "Загрузить",
    blocks: "Блоки",
    blockListIsEmpty: "Список блоков пуст",
    selectBlock: "Добавить блок",
    save: "Сохранить",
    watch: "Смотреть",
    close: "Закрыть",
    back: "Назад",
    broadcast: "Трансляция",
    senderAddress: "Адрес отправителя",
    globalEmailTooltip: `Будет использоваться для всех писем в
    рамках этого мероприятия`,
    senderName: "Имя отправителя",
    settingsPosterTooltip: `Будет использоваться для всех писем в
    рамках этого мероприятия. При
    необходимости можно изменить. Для этого
    зайдите в раздел шаблоны и загрузите
    необходимое изображение .jpg или .png.
    Разрешение не должно превышать 1920x1080
    px, размер файла не более 1 мб`,
    open: "Открыть",
    font: "Шрифт",
    platformLink: "Ссылка на платформу в письме",
    containsToken: "Содержит токен",
    yes: "Да",
    no: "Нет",
    hasntTokenTooltip: `Если выбрано <b>"НЕТ"</b>, то ссылка на платформу будет иметь общий адрес, и пользователь,
    переходя по ней, должен будет ввести свой адрес электронной почты и одноразовый код для доступа к платформе.`,
    hasTokenTooltip: `Ссылка содержит токен.
    При переходе по такой ссылке информация о пользователе будет автоматически извлечена из его регистрационных данных,
    и ему не придется вводить одноразовый код при входе на платформу. Чтобы изменить этот параметр, перейдите в настройки мероприятия.`,
    colorScheme: "Цветовая схема",
    darkTheme: "Темная",
    lightTheme: "Светлая",
    accentTheme: "Акцентная",
    accentColor: "Акцентный цвет",
    darkColor: "Темный цвет",
    lightColor: "Светлый цвет",
    socialNetworks: "Социальные сети",
    footerTemplateTooltip: `Будут отображаться в футере письма.
    Добавьте ссылку и кнопка появится в
    письме`,
    vk: "ВКонтакте",
    classmates: "Одноклассиники",
    telegram: "Телеграмм",
    dzen: "Дзен",
    selectAtLeastOneBlock: "Выберите хотя бы один блок",
    setTemplateName: "Укажите название шаблона",
    setMailSubject: "Укажите тему письма",
    availableValues: "Доступные значения",
    removeTemplate: "Удалить шаблон",
    disclaimerTitle: "Дисклеймер",
    disclaimerTooltip: `Это системное сообщение,
    отображается в письме рядом с кнопкой
    перехода на платформу для онлайн или офлайн участника`,
    smtpServerSettings: "Настройки SMTP сервера",

    // Event calendar settings
    eventCalendarSaveError: "Ошибка при сохранении настроек календаря",
    eventCalendarOnlineTitle:
        "Информация для добавления в календарь онлайн участника",
    eventCalendarOfflineTitle:
        "Информация для добавления в календарь офлайн участника",
    eventCalendarOnlineInfoModalLabel:
        "Информация для добавления в календарь онлайн участника",
    eventCalendarOfflineInfoModalLabel:
        "Информация для добавления в календарь офлайн участника",
    eventCalendarOnlineAddLinkModalLabel:
        "Добавить ссылку на платформу онлайн в описание мероприятия в календаре",
    eventCalendarOfflineAddLinkModalLabel:
        "Добавить ссылку на платформу офлайн в описание мероприятия в календаре",
    eventCalendarEventNameModalLabel: "Название мероприятия в календаре",
    eventCalendarEventDescrModalLabel: "Описание мероприятия в календаре",
    eventCalendarEventAddAddressModalLabel:
        "Добавить адрес мероприятия в календарь",
    eventCalendarEventAddressModalLabel: "Адрес мероприятия",
});
